import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import './assets/css/common.css';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const app = createApp(App);

const pinia = createPinia();

app.use(router);

app.use(pinia);

app.mount('#app');
